import React from 'react';

export interface SeguroIconProps {
  size?: number | string;
  color?: string;
  className?: string;
}

const SeguroIcon: React.FC<SeguroIconProps> = ({ 
  size = 24, 
  color = 'currentColor',
  className = '' 
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 26 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ color }}
    >
      <g filter="url(#a)"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m10.109 14.633 2 2 4-4M12.75 24.75s8-4 8-10v-7l-8-3-8 3v7c0 6 8 10 8 10"/></g><defs><filter id="a" width="32" height="32" x="-3.25" y="-1.25" color-interpolation-filters="sRGB" filterUnits="userSpaceOnUse"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/><feOffset/><feGaussianBlur stdDeviation="2"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"/><feBlend in2="BackgroundImageFix" mode="overlay" result="effect1_dropShadow_229_35801"/><feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/><feOffset dy="1"/><feGaussianBlur stdDeviation=".5"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"/><feBlend in2="effect1_dropShadow_229_35801" mode="multiply" result="effect2_dropShadow_229_35801"/><feBlend in="SourceGraphic" in2="effect2_dropShadow_229_35801" result="shape"/></filter></defs>
    </svg>
  );
};

export default SeguroIcon;
